export default "__VITE_ASSET__BRVMqNBZ__"